export default __webpack_public_path__ + "static/media/img29_s.dc977346.png";